module.exports = __webpack_public_path__ + "img/gzhm.7164f59c.jpeg";